import { HttpHelper } from "../helper/http-helper-service";
import { isFormVisibleToContact } from "@/form/form-visibility";
import PrototypeInstance from "../helper/prototype-instance";
import { constants } from "../constant/constants";
import {
  FormRequestModel,
  FormSubmissionEmailModel,
} from "../model/form/form-model";
import { formEntity } from "../model/entity/form-entity";

import api from "../Axios/axios";

export default class formService {
  static createShareableLink(object: any) {
    return HttpHelper.postData(
      constants.apiUrl.formUrls.createShareableLink,
      object,
    );
  }

  static getFormList() {
    return HttpHelper.getData(constants.apiUrl.formUrls.getFormList);
  }

  static getFormContentByFormId(formId: string) {
    return HttpHelper.getData(
      constants.apiUrl.formUrls.getFormContentByFormId.replace("{id}", formId),
    );
  }

  static getFormResponse(responseId: string) {
    return HttpHelper.getData(
      constants.apiUrl.formUrls.getFormResponseCx.replace("{id}", responseId),
    );
  }

  static async getFormById(formId: string) {
    let clientId =
      PrototypeInstance.globalProperties.$store.getters[
        "ContactModule/getClientId"
      ];

    let form: formEntity = await HttpHelper.getData(
      constants.apiUrl.formUrls.getFormById.replace("{id}", formId),
    );

    const contact =
      PrototypeInstance.globalProperties.$store.getters["ContactModule/getContact"];
    if (isFormVisibleToContact(form, { clientId, tagIds: contact?.tagIds })) {
      return form;
    } else {
      formEntity.delete((form) => {
        return form.id == formId;
      });
    }
  }

  //Form Drafts
  static getFormDraftList(createdByContactId: number) {
    let testUrl: string = constants.apiUrl.formUrls.getFormDraftList.replace(
      "{createdById}",
      createdByContactId.toString(),
    );
    return HttpHelper.getData(testUrl);
  }

  static getFormDraftContentByFormId(formId: string) {
    return HttpHelper.getData(
      constants.apiUrl.formUrls.getFormDraftContentByFormId.replace(
        "{id}",
        formId,
      ),
    );
  }

  static createFormDraft(object: FormRequestModel) {
    return HttpHelper.postData(constants.apiUrl.formUrls.createForm, object);
  }

  static updateFormDraft(object: FormRequestModel) {
    return HttpHelper.patchData(constants.apiUrl.formUrls.updateForm, object);
  }
  //End Form Drafts
  static async submitForm(object: any) {
    // Signed-in contacts submit through the Form API so the backend knows who submitted.
    // Goes through HttpHelper (not the bare `api` instance) so the request carries the
    // Authorization / subscription-key headers; without them the gateway answers 401.
    return HttpHelper.postData(
      constants.apiUrl.formUrls.sendFormResponseCx,
      object,
    );
  }

  static deleteForm(formId: string) {
    return HttpHelper.deleteData(
      constants.apiUrl.formUrls.deleteFormDraft.replace("{id}", formId),
      {},
    );
  }

  static sendFormEmail = async (
    emailModel: FormSubmissionEmailModel,
    header: any,
  ) => {
    if (header) {
      api.interceptors.request.use((config) => {
        const herderValue: string =
          PrototypeInstance.globalProperties.$store.getters[
            "MasterModule/getFormEmailKey"
          ];
        config.headers["emailKey"] = herderValue;
        return config;
      });
    }

    const response = await api.post<boolean>(
      constants.apiUrl.PublicFunctionsUrls.sendFormEmail,
      emailModel,
    );
    return response.data;
  };
}
